/**
 * MUI's `components` map, one file per entry, each with its own constants and helpers — nothing is
 * shared between them but the tokens and `theme/typography`.
 *
 * The `*-glyphs.tsx` files are not entries: they are the JSX an entry hands to `defaultProps`,
 * which a `.ts` config file cannot hold. They sit beside the entry that is their only consumer.
 *
 * Order is preserved from the single-file version for reviewable diffs; it has no effect on the
 * emitted CSS, which MUI serializes per component as it renders.
 */

import { type ThemeOptions } from "@mui/material/styles";

import { MuiAlert, MuiAlertTitle } from "theme/components/alert";
import { MuiBreadcrumbs } from "theme/components/breadcrumbs";
import { MuiButton, MuiIconButton } from "theme/components/button";
import { MuiCheckbox } from "theme/components/checkbox";
import { MuiChip } from "theme/components/chip";
import {
  MuiDateCalendar,
  MuiDayCalendar,
  MuiPickerDay,
  MuiPickerPopper,
  MuiPickersCalendarHeader,
  MuiPickersOutlinedInput,
  MuiYearCalendar,
} from "theme/components/date-picker";
import { MuiDialog } from "theme/components/dialog";
import { MuiFormHelperText, MuiFormLabel, MuiOutlinedInput } from "theme/components/forms";
import { MuiLink } from "theme/components/link";
import { MuiPagination, MuiPaginationItem } from "theme/components/pagination";
import { MuiRadio } from "theme/components/radio";
import { MuiAutocomplete } from "theme/components/select";
import { MuiSwitch } from "theme/components/switch";
import { MuiTableCell } from "theme/components/table";
import { MuiTooltip } from "theme/components/tooltip";

export const components: ThemeOptions["components"] = {
  MuiButton,
  MuiIconButton,
  MuiChip,
  MuiOutlinedInput,
  MuiFormLabel,
  MuiTableCell,
  MuiFormHelperText,
  MuiAutocomplete,
  MuiSwitch,
  MuiCheckbox,
  MuiRadio,
  MuiTooltip,
  MuiDialog,
  MuiPickersOutlinedInput,
  MuiPickerPopper,
  MuiDateCalendar,
  MuiPickersCalendarHeader,
  MuiDayCalendar,
  MuiPickerDay,
  MuiYearCalendar,
  MuiPagination,
  MuiPaginationItem,
  MuiLink,
  MuiBreadcrumbs,
  MuiAlert,
  MuiAlertTitle,
};
